/**
 * Returns new array instance with unique values.
 * @param arr
 * @returns
 */
function uniq<T>(arr: Array<T>): Array<T> {
  return [...new Set(arr)]
}

export default uniq
